import React, { Component } from 'react';
import { connect } from 'dva';
import moment from 'moment';
// eslint-disable-next-line import/no-extraneous-dependencies
import router from 'umi/router';
import { Button, Row, Col, Form, Input, Divider, Tooltip } from 'antd';
import Container from '../../../../../components/Container';
import ListPage from '../../../../../components/ListPage';
import { getAppCode } from '../../utils/utils';
import styles from './index.less';

const { ListTable, ListCreate } = ListPage;

@connect(({ moduleList }) => ({
  ...moduleList,
}))
class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [],
      dataSource: [],
      loading: false,
      totalElements: 0,
      params: {
        templateTitle: '',
        appCode: getAppCode(),
        page: 1,
        pageSize: 10,
      },
    };
  }

  componentDidMount() {
    const { params } = this.state;
    this.setColumns();
    this.fetchLists(params);
  }

  search = e => {
    e.preventDefault();
    const { form } = this.props;

    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const { params } = this.state;
        const tempParams = {
          ...params,
          templateTitle: values.templateTitle ? encodeURIComponent(values.templateTitle) : '',
          page: 1,
        };
        this.setState({
          params: tempParams,
        });
        this.fetchLists(tempParams);
      }
    });
  };

  reSet = () => {
    const { form } = this.props;
    form.resetFields();
    const { params } = this.state;
    const tempParams = { ...params, templateTitle: '', page: 1 };
    this.setState({
      params: tempParams,
    });
    this.fetchLists(tempParams);
  };

  fetchLists = params => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'moduleList/fetchLists',
      params,
    })
      .then(res => {
        this.setState({
          loading: false,
          dataSource: res.content,
          totalElements: res.totalElements,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  setColumns = () => {
    const columns = [
      {
        title: '标题',
        dataIndex: 'templateTitle',
        key: 'templateTitle',
        fixed: 'left',
        width: 330,
        render: text => {
          if (text.length <= 20) {
            return <span>{text}</span>;
          }
          return (
            <Tooltip placement="top" title={text}>
              <span>{text.substring(0, 20)}...</span>
            </Tooltip>
          );
        },
      },
      {
        title: '类型',
        dataIndex: 'templateType',
        key: 'templateType',
        width: 160,
        render: text => {
          return text ? <span>{text}</span> : '-';
        },
      },
      {
        title: '关联学校数',
        dataIndex: 'relatedCount',
        key: 'relatedCount',
        width: 120,
        render: text => {
          return text === -1 ? '所有' : text;
        },
      },
      {
        title: '最后编辑人员',
        dataIndex: 'modifyUserName',
        key: 'modifyUserName',
      },
      {
        title: '最后编辑时间',
        dataIndex: 'gmtModify',
        key: 'gmtModify',
        render: (text, record) => {
          return <span>{moment(text || record.createTime).format('YYYY.MM.DD HH:mm')}</span>;
        },
      },

      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        width: 160,
        fixed: 'right',
        render: (text, record) => {
          return (
            <span>
              <a
                onClick={e => {
                  e.stopPropagation();
                  router.push(
                    `/microsite/module/manage/create?id=${record.id}&appCode=${getAppCode()}`
                  );
                }}
              >
                编辑
              </a>
              <Divider type="vertical" />
              <a
                onClick={e => {
                  e.stopPropagation();
                  router.push(
                    `/microsite/module/manage/associated?id=${record.id}&appCode=${getAppCode()}`
                  );
                }}
              >
                关联
              </a>
            </span>
          );
        },
      },
    ];
    this.setState({ columns });
  };

  changePage = (page, pageSize) => {
    const { params } = this.state;
    const tempParams = {
      ...params,
      page,
      pageSize,
    };
    this.setState({ params: tempParams });
    this.fetchLists(tempParams);
  };

  // 跳转详情
  handleGoToDetail = id => {
    router.push(
      `/microsite/submissions/submissions/approvalDetail?id=${id}&appCode=${getAppCode()}}`
    );
  };

  render() {
    const { columns, loading, dataSource, params, totalElements } = this.state;
    const { page } = params;
    const { form } = this.props;
    const { getFieldDecorator } = form;
    const formItemLayout = {
      labelCol: { span: 7 },
      wrapperCol: { span: 17 },
    };

    const pageProps = {
      spinProps: { spinning: loading },
      className: styles['module-list'],
    };

    const tableProps = {
      pageInfo: { totalElements, page },
      columns,
      list: dataSource,
      rowKey: 'id',
      onPageChange: this.changePage,
    };

    const createBtn = {
      btnText: '新建模板',
      onCreate: () => router.push(`/microsite/module/manage/create?appCode=${getAppCode()}`),
    };

    return (
      <Container breStates isSplitBar>
        <ListPage {...pageProps}>
          <section className={styles['search-area']}>
            <Row>
              <Col span={8}>
                <Form.Item {...formItemLayout} label="标题">
                  {getFieldDecorator('templateTitle', {
                    rules: [
                      {
                        max: 50,
                        message: '请勿超过50个字!',
                      },
                    ],
                  })(<Input placeholder="请输入标题" onPressEnter={this.search} />)}
                </Form.Item>
              </Col>

              <Col offset={20} style={{ textAlign: 'right' }}>
                <Form.Item>
                  <Button type="primary" onClick={this.search}>
                    查询
                  </Button>
                  <Button onClick={this.reSet}>重置</Button>
                </Form.Item>
              </Col>
            </Row>
          </section>

          <section className="table-area">
            <ListCreate {...createBtn} />
            <ListTable {...tableProps} />
          </section>
        </ListPage>
      </Container>
    );
  }
}

const ListFrom = Form.create()(List);
export default ListFrom;
